module.exports = __webpack_public_path__ + "img/otp-phone.9bb6f61a.png";